import { RampPgApiSdk } from '../api/RampPgApiSdk';
import {
    brandIdValPath,
    mockServerBaseUrl,
    proxyServerBaseUrl,
    regionIdValPath
} from '../constants/Constants';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { TranslationRepository } from '../internal/repositories/TranslationRepository';
import { diContainer, serviceNames } from '../service-setup/diContainer';
import { DropdownDataStore } from '../internal/repositories/DropdownDataStore';

export class RampServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private dropdownDataStore: DropdownDataStore;
    private rampPgApiSdk: RampPgApiSdk;
    private translationRepository: TranslationRepository;

    constructor() {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.dropdownDataStore = diContainer.get(serviceNames.dropdownDataStore);
        this.rampPgApiSdk = diContainer.get(serviceNames.rampPgApiSdk);
        this.translationRepository = diContainer.get(serviceNames.translationRepository);
    }

    public execute = async () => {
        await this.configRepository.getDefaultConfigs();
        const { config } = this.configRepository.config;
        const { rampForm, businessUnitId = '' } = config;
        await this.dropdownDataStore.loadDropdownData(rampForm?.staticLookupUrls);

        const { getSignUpTranslations } = this.translationRepository;
        !!rampForm && (await getSignUpTranslations(rampForm.signUpFormInputSchema.sections));

        const baseUrl = USE_MOCK_SERVER
            ? mockServerBaseUrl
            : USE_PROXY_SERVER
            ? proxyServerBaseUrl
            : window.location.origin;
        this.rampPgApiSdk.setup({
            regionId: config[regionIdValPath] || '',
            brandId: config[brandIdValPath] || '',
            token: config.pgApiTokens?.rampForm || '',
            baseUrl,
            businessUnitId
        });
    };
}
